import { getHoffmanEnvironment } from '../services/windowService';

const { GTM_MEASUREMENT_ID = '' } = getHoffmanEnvironment();

export const googleTagManagerConfig = {
  gtmMeasurementId: GTM_MEASUREMENT_ID,
};
